import React from 'react'
import PropTypes from 'prop-types'
import { NumberInput, required } from 'react-admin'

const NumberWidget = props => (
    <div>
        <NumberInput
            source={props.fieldName}
            label={props.label}
            validate={ props.required ?  required() : null}
            {...props.styleProps}
        />
    </div>
)

NumberWidget.propTypes = {
    schema: PropTypes.object.isRequired,
    fieldName: PropTypes.string,
    label: PropTypes.string,
    normalizer: PropTypes.func,
}

export default NumberWidget
